<div *ngIf="(submitting$ | async) === false; else submitting" class="flex flex-col" style="gap: 36px">
  <div class="flex flex-col flex-1" style="gap: 16px; margin-bottom: 12px">
    <h2 class="nomargin">Managed Smart Devices</h2>
    <div class="grid" style="grid-template-columns: 20px 1fr; gap: 12px">
      <ng-container *ngFor="let feature of features">
        <span><sbnb-icon icon="check" class="text-grass-darker"></sbnb-icon></span>
        <span class="text__large">{{ feature }}</span>
      </ng-container>
    </div>
  </div>
  <div class="flex flex-col" style="gap: 12px">
    <sbnb-hero-card>
      <div class="flex flex-col flex-1 justify-center">
        <div class="flex justify-between" style="gap: 6px">
          <div class="text__large">Important things to know</div>
          <sbnb-price-callout
            *ngIf="smartDevicePrice$ | async as price"
            prefix="+"
            [amount]="price.formatted_string"
            [currency]="price.currency"
            per="connected device"
            perAddendum="at an active property"
            size="small"></sbnb-price-callout>
        </div>

        <div class="grid" style="grid-template-columns: 20px 1fr; gap: 12px">
          <sbnb-icon icon="sync" class="text-smoke-darker"></sbnb-icon>
          <span>Connected smart devices will be allowed immediately</span>

          <span><img src="/assets/iconography/help-documents.svg" /></span>
          <span>You will only be billed for devices that are matched with at least 1 active property</span>

          <span><img src="/assets/iconography/help-documents.svg" /></span>
          <span>Add-ons are added to your regular invoice</span>
        </div>
      </div>
    </sbnb-hero-card>

    <mat-divider style="margin-top: 12px; margin-bottom: 6px"></mat-divider>
    <div>
      <mat-checkbox style="padding: 0; align-items: start" [formControl]="confirmDeviceAddon" class="flex items-start">
        <strong>I confirm I understand that this is a billed add-on</strong>
      </mat-checkbox>
    </div>
  </div>
  <div class="flex w-full justify-between">
    <button mat-flat-button class="button__secondary" (click)="leaveWizard()" [disabled]="submitting$ | async">
      Cancel
    </button>
    <div class="flex justify-end" style="gap: 12px">
      <button
        mat-flat-button
        class="button__primary"
        (click)="activateDeviceAddon()"
        [disabled]="confirmDeviceAddon.invalid || (submitting$ | async)">
        Accept
      </button>
    </div>
  </div>
</div>

<ng-template #submitting>
  <sbnb-loading-spinner minHeight="300px"></sbnb-loading-spinner>
</ng-template>
